import type { OperationHistory } from "@zhihaoscm/entity";
import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";

export class OperationHistoryService extends BaseService<any, OperationHistory, any, any> {
    /** 查询操作人列表 */
    async findByModuleOfShip(params: { module: number; bizNo: string }): Promise<OperationHistory[]> {
        const { data } = await this.service.get(`${this.path}/findByModuleOfShip`, { params });
        return data;
    }
}
export const operationHistoryService = new OperationHistoryService("/operationHistory", httpRequest);
